import React from 'react';
import styles from '../OrderStatus.module.css';

const ProductsDetails = (props) => {

  function getStatus(product) {
    if (props.purchaseStatus == 'shipped') {
      return 'Shipped';
    }

    if (product.qty.available <= 0) {
      return 'Out of Stock';
    } else if (product.qty.available < product.order_data.purchase_part_qty) {
      return 'Partial Stock';
    }

    return 'In Stock';
  }

  return (
    <>
      <h2 className={styles.heading}>ORDER DETAILS</h2>
      <table className={styles.table}>
        <tbody>
          <tr>
            <th className={styles.tableHeading}>Qty</th>
            <th className={styles.tableHeading}>Cat #</th>
            <th className={styles.tableHeading}>Item</th>
            <th className={styles.tableHeading}>Status</th>
          </tr>
          {props.products?.map((product, index) => {
            let color = index % 2 == 0 ? '#ebebeb' : 'white';

            return (
              <tr key={product.product_id} style={{ backgroundColor: color }}>
                <td className={styles.productData}>
                  {product.order_data.purchase_part_qty}
                </td>
                <td className={styles.productData}>
                  {product.product_id}
                </td>
                <td className={styles.productData}>
                  <a href={product.link}>{product.product_name}</a>
                </td>
                <td className={styles.productData}>
                  {getStatus(product)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default ProductsDetails;